module.exports = __webpack_public_path__ + "static/media/DSC_0881.ff8f3c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0881.jpg
// module id = 612
// module chunks = 0